import { NewDatePipe } from './newDate.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [NewDatePipe],
  providers: [NewDatePipe],
  exports: [NewDatePipe]
})
export class NewDatePipeModule { }
